










































































































import ApplicationCountBar from './ApplicationCountBar.vue';
import CountryDistributionPie from './CountryDistributionPie.vue';
import StudentOfferInformations from './StudentOfferInformations.vue';
import StudentApplicationStatus from './StudentApplicationStatus.vue'
import { Component, Vue, Watch } from 'vue-property-decorator';
import {
  gearDatasApi,
  gearStudentCountDatasApi,
  getGearShortcutMenuListApi,
  getPersonalAgentAcKpiSourceApi,
} from '@/api/index';
import { UserModule } from '@/store/modules/user';
import { AppModule } from '@/store/modules/app';

@Component({
  name: 'applicationSummary',
  components: {
    ApplicationCountBar,
    CountryDistributionPie,
    StudentOfferInformations,
    StudentApplicationStatus,
  }
})
export default class extends Vue {
  get showPie() {
    const countryStudentCount = this.countryStudentCount;
    return countryStudentCount && countryStudentCount.length;
  }
  get showChart() {
    const applyStudentCount = this.applicationCountBarData.allApplyStudentCount;
    return applyStudentCount && applyStudentCount.length;
  }

  get language() {
    return AppModule.language;
  }

  get successProportion() {
    return this.enrolledSuccessProportion ? this.enrolledSuccessProportion + '%' : '0%';
  }

  get totalNum() {
    return this.studentTotalNum || 0;
  }

  get totalSum() {
    return this.studentTotalSum || 0;
  }

  get year() {
    return UserModule.indexSelectYear || '0';
  }

  public statusBall: any[] = []

  // public year: string = '0';
  public goProScore = 0;
  public originUserName: string = UserModule.name;
  public yearOptions: any = [];
  public studentTotalNum: number = 0; // 学生数
  public studentTotalSum: number = 0; // 申请数
  public enrolledSuccessProportion: number = 0;
  public thisYearApplyStudentCountTotal: number | string = ''; // 今年学生数
  public thisYearEnrolledStudentTotal: number | string = ''; // 今年申请数
  public allYearEnrolledStudentTotal: number | string = '';
  public allApplyStudentCountTotal: number | string = '';
  public studentCountRecords: any[] = [];
  public countryStudentCount: any[] = [];
  public studentStatisticalStatus: any[] = [];
  public applicationCountBarData: any = {
    allApplyStudentCount: [],
    allEnrolledStudentCount: [],
    thisYearApplyStudentCount: [],
    thisYearEnrolledStudentCount: [],
  };

  public quickAccessList: any = [];

  @Watch('year')
  public onYearChange() {
    this.getSummaryDatas();
  }

  @Watch('language', { immediate: true })
  public onLanguageChange() {
    const statusBall = [
      {
        name: this.$t('index.pending'),
        stepKey: "pendingCount",
        ids: '21',
      },
      {
        name: this.$t('index.stepNewAppCount'),
        stepKey: "newAppCount",
        ids: '1',
      },
      {
        name: this.$t('index.submitted'),
        stepKey: "submittedCount",
        ids: '2,3,11,12'
      },
      {
        name: this.$t('index.admittedOffer'),
        stepKey: "admittedCount",
        ids: '4,19'
      },
      {
        name: this.$t('index.paid'),
        stepKey: "depositPaidCount",
        ids: '5,6,7,10,13,14,15,17'
      },
      {
        name: this.$t('index.signedSucc'),
        stepKey: "enrolledCount",
        ids: '8'
      },
    ]
    const data = this.statusBall;
    this.statusBall = statusBall.map((item) => {
      const statusItem = data.find((status: any) => item.stepKey === status.stepKey);
      return {
        ...item,
        value: statusItem ? statusItem.value : 0
      }
    })
  }

  public mounted() {
    this.getSummaryDatas();
    this.getGearShortcutMenuList();
    this.getPersonalAgentAcKpiSource();
  }

  public getImageUrl(url: string) {
    try {
      return require('@/assets/image/' + url);
    } catch(err) {
      return '';
    }
  }

  public async getGearShortcutMenuList() {
    try {
      const { data } = await getGearShortcutMenuListApi();
      console.log(data);
      this.quickAccessList = data.datas;
    } catch (error) {
      //
    }
  }

  public async getPersonalAgentAcKpiSource() {
    try {
      const { data } = await getPersonalAgentAcKpiSourceApi();
      if (data.data) {
        this.goProScore = data.data.ttlScore;
      }
    } catch (error) {
      //
    }
  }

  public quickAccess(name: string) {
    let params = {};
    if (name === 'contactPerson') {
      params = {
        id: 'add'
      }
    }
    this.$router.push({
      name,
      params
    })
  }

  public handleLinkTo(name: string) {
    const year = this.year === '0' ? '' : this.year;
    this.$router.push({
      name,
      query: { year },
    })
  }

  public handleClickStatusBall(step: any) {
    if (step.value === 0) { 
      return this.$confirm(this.$t('common.noData') as string, '', {
        confirmButtonText: this.$t('common.confirm') as string,
        showCancelButton: false,
        type: 'info',
      })
    };
    const year = this.year === '0' ? '' : this.year;
    const stepId = step.ids;
    this.$router.push({
      name: 'applicationList',
      query: { stepId, year },
    })
  }

  public async getSummaryDatas() {
    const { data } = await gearDatasApi(this.year);
    const summaryDatas = data.data;
    this.yearOptions = summaryDatas.allYears;
    this.enrolledSuccessProportion = summaryDatas.enrolledSuccessProportion;
    this.studentTotalNum = summaryDatas.studentTotalNum;
    this.studentTotalSum = summaryDatas.studentTotalSum;
    this.studentCountRecords = summaryDatas.studentCountRecords;
    this.countryStudentCount = summaryDatas.countryStudentCount;
    this.studentStatisticalStatus = summaryDatas.studentOfferItemStatisticalStatusDtos;
    this.allApplyStudentCountTotal = summaryDatas.allApplyStudentCountTotal;
    this.allYearEnrolledStudentTotal = summaryDatas.allYearEnrolledStudentTotal;
    this.thisYearEnrolledStudentTotal = summaryDatas.thisYearEnrolledStudentTotal;
    this.thisYearApplyStudentCountTotal = summaryDatas.thisYearApplyStudentCountTotal;
    this.applicationCountBarData = Object.assign({},
      { allApplyStudentCount: summaryDatas.allApplyStudentCount,
        allEnrolledStudentCount: summaryDatas.allEnrolledStudentCount,
        thisYearApplyStudentCount: summaryDatas.thisYearApplyStudentCount,
        thisYearEnrolledStudentCount: summaryDatas.thisYearEnrolledStudentCount
      }
    );
    const gearStepStatisticsDto = summaryDatas.gearStepStatisticsDto;
    this.statusBall = this.statusBall.map((item: any) => {
      item.value = gearStepStatisticsDto[item.stepKey]
      return item;
    });
  }

  public async updateOfferInformations(dataRange: any) {
    if (!dataRange || !dataRange.length) {
      this.getSummaryDatas();
      return;
    }
    const params = {
      endDate: dataRange[1],
      startDate: dataRange[0]
    }
    const { data } = await gearStudentCountDatasApi(params);
    this.studentCountRecords = data.data || [];
  }
}
